import { defineComponent, h } from 'vue';

export default defineComponent({
  name: 'FilterDropdownMenuWrapper',
  setup(_props, { slots }) {
    return () => h('div', { onClick: (event: MouseEvent) => event.stopPropagation() }, slots.default?.());
  }
});
